import React from "react";
import { useLang } from "../LangContext";
import { IMAGES } from "../i18n";
import { motion } from "framer-motion";

export default function Mission() {
    const { t } = useLang();
    return (
        <section id="mission" data-testid="mission-section" className="relative py-24 md:py-32 px-6 md:px-12 bg-ink">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                <div className="lg:col-span-5">
                    <span className="text-xs font-mono uppercase tracking-[0.3em] text-volt">
                        — {t.mission.label}
                    </span>
                    <h2 className="font-graffiti text-4xl md:text-5xl lg:text-6xl tracking-tight mt-6 text-white leading-[0.95]">
                        {t.mission.title}
                    </h2>
                    <div className="mt-8 aspect-[4/5] w-full overflow-hidden border border-white/10">
                        <img
                            src={IMAGES.impact}
                            alt="Brussels youth athlete"
                            className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
                        />
                    </div>
                </div>

                <div className="lg:col-span-7 lg:pl-12 lg:border-l border-white/10 space-y-6 text-zinc-300 text-lg leading-relaxed">
                    <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
                        {t.mission.body1}
                    </motion.p>
                    <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }}>
                        {t.mission.body2}
                    </motion.p>
                    <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }}>
                        {t.mission.body3}
                    </motion.p>

                    <blockquote className="mt-10 border-l-2 border-volt pl-6 py-2">
                        <p className="font-display text-2xl md:text-3xl text-white uppercase leading-tight tracking-tight">
                            "{t.mission.quote}"
                        </p>
                        <footer className="mt-3 text-sm text-zinc-500 uppercase tracking-wider">
                            — {t.mission.quoteAuthor}
                        </footer>
                    </blockquote>

                    <a href="#donate" data-testid="mission-cta" className="mt-10 btn-volt inline-flex items-center gap-2 px-6 py-3 text-xs w-fit">
                        {t.nav.help} →
                    </a>
                </div>
            </div>
        </section>
    );
}
